import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isLoggedIn } from './authentication'

const AdminRoute = ({ component: Component, ...rest }, replace) => (
  <Route
    {...rest}
    render={props => (
      isLoggedIn() === true
        ? <Component {...props} /> 
        : <Redirect to={{
          pathname: '/admin/login',
          state: { from: props.location }
      }} />
    )}
  />
)

AdminRoute.propTypes = {
  component: PropTypes.func.isRequired,
}

export default AdminRoute
